module.exports = __webpack_public_path__ + "static/media/noimage.beb40475.jpg";